// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.CreateGuestInvoiceRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateGuestInvoiceRequest extends GandalfModelBase {

	@GandalfLabel('Address Line 1')
	@GandalfValidator({ sizeString: { message: 'Address Line 1 cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	addressLine1!: string | null;

	@GandalfLabel('Address Line 2')
	@GandalfValidator({ sizeString: { message: 'Address Line 2 cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	addressLine2!: string | null;

	@GandalfLabel('City')
	@GandalfValidator({ sizeString: { message: 'City cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	city!: string | null;

	@GandalfLabel('Email')
	@GandalfValidator({ email: { message: 'Invalid email format' } })
	@GandalfValidator({ sizeString: { message: 'Email cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfLabel('Name')
	@GandalfValidator({ sizeString: { message: 'Name cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfLabel('Phone number')
	@GandalfValidator({ phoneNumber: { message: 'Contact phone must contain at least 10 digits' } })
	@GandalfProperty({ designType: String })
	phoneNumber!: string | null;

	@GandalfLabel('Zip Code')
	@GandalfValidator({ sizeString: { message: 'Zip Code cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfValidator({ postalCode: { message: 'Zip code is invalid' } })
	@GandalfProperty({ designType: String })
	postalCode!: string | null;

	@GandalfLabel('State Province')
	@GandalfValidator({ sizeString: { message: 'State Province cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	stateProvince!: string | null;

}
